<template>
   <div>
      <v-container>
         <v-row class="pt-5"></v-row>
         <v-form ref="roleform" v-model="roleform_valid">
            <v-row>
               <v-toolbar dense :color="this.$globalstore.secondary_titleclass" bottom>
                  <v-toolbar-title>Add Role</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn color="indigo" class="white ma-2" outlined @click="SaveRole">
                     Save
                  </v-btn>
                  <v-btn color="indigo" class="white ma-2" outlined @click="goBack()">
                     Back
                  </v-btn>
               </v-toolbar>
            </v-row>
            <v-row>
               <v-col md="6">
                  <v-card flat outlined class="pl-5 pr-10 pb-5">
                     <v-text-field
                        ref="locname"
                        label="Name"
                        v-model="edit_role_name"
                        required
                        :rules="rules_role_name"
                     >
                     </v-text-field>

                     <v-text-field
                        label="Description"
                        v-model="edit_role_description"
                        required
                        :rules="rules_role_description"
                     >
                     </v-text-field>
                  </v-card>
               </v-col>
               <v-col md="6">
                  <v-card flat outlined class="pl-5 pr-10 pb-5">
                     <v-select
                        label="Status"
                        :items="$globalstore.status_select"
                        item-text="text"
                        item-value="id"
                        return-object
                        v-model="edit_role_status"
                        required
                     ></v-select>
                  </v-card>
               </v-col>
            </v-row>
            <v-row>
               <v-col cols="5">
                  <v-card flat outlined>
                     <v-card-text class="py-1"><b>Assigned Capabilities</b></v-card-text>
                     <v-data-table
                        v-model="rolecaplist_select"
                        dense
                        :headers="cap_header"
                        :items="rolecaplist"
                        @click:row="caplist_rowClick"
                        item-key="cap_id"
                        sort-by="cap_id"
                        single-select
                     >
                     </v-data-table>
                  </v-card>
               </v-col>
               <v-col cols="1">
                  <v-card flat class="pa-2 mt-10 mb-4">
                     <v-btn outlined color="teal" @click="moveToRole">
                        <v-icon>mdi-arrow-left-bold</v-icon>
                     </v-btn>

                     <v-btn outlined color="orange" class="pa-2 my-4" @click="moveFromRole">
                        <v-icon>mdi-arrow-right-bold</v-icon>
                     </v-btn>
                  </v-card>
               </v-col>
               <v-col cols="6">
                  <v-card flat outlined>
                     <v-card-text class="py-1"><b>Available Capabilities</b></v-card-text>
                     <v-data-table
                        v-model="capmaster_select"
                        dense
                        :headers="capmaster_header"
                        :items="capmasterlist"
                        @click:row="capmasterlist_rowClick"
                        sort-by="cap_id"
                        item-key="cap_id"
                        single-select
                     >
                     </v-data-table>
                  </v-card>
               </v-col>
            </v-row>
         </v-form>
      </v-container>
      <confirm-dialog ref="confirm" />
   </div>
</template>

<script>
   import GlobalConstant from "../common/globalconstant.js";

   import ConfirmDlg from "@/components/ConfirmDlg";

   export default {
      components: {
         "confirm-dialog": ConfirmDlg,
      },

      data() {
         return {
            capmaster_range: GlobalConstant.CAPMASTER_RANGE,
            edit_role_name: "",
            edit_role_description: "",
            edit_role_status: null,
            roleform_valid: true,
            rules_role_name: [(v) => !!v || "Name is required"],
            rules_role_description: [(v) => !!v || "Description is required"],

            cap_header: [
               {
                  text: "Cap ID",
                  value: "cap_id",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Name",
                  value: "cap_name",
                  class: this.$globalstore.table_headerclass,
               },
            ],
            rolecaplist: [],
            capmaster_header: [
               {
                  text: "Cap ID",
                  value: "cap_id",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Name",
                  value: "cap_name",
                  class: this.$globalstore.table_headerclass,
               },
            ],
            capmasterlist: [],
            rolecaplist_index: -1,
            capmasterlist_index: -1,
            rolecaplist_select: [],
            capmaster_select: [],
         };
      },
      methods: {
         goBack() {
            this.$router.go(-1);
         },

         async getCapMasterList() {
            let response = await this.$http({
               url: "/common/getcapmasterlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  range: this.capmaster_range,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.capmasterlist = response.data.capmasterlist;
               } else {
                  this.capmasterlist = [];
               }
            });
         },

         moveToRole() {
            if (this.capmaster_select) {
               let item = this.capmaster_select[0];
               if (!this.rolecaplist.some((x) => x.cap_id == item.cap_id)) {
                  let index = this.capmasterlist.findIndex((x) => x.cap_id == item.cap_id);
                  this.rolecaplist.push(item);
                  this.capmasterlist.splice(index, 1);
                  this.capmaster_select = [];
               }
            }
         },

         moveFromRole() {
            if (this.rolecaplist_select) {
               let item = this.rolecaplist_select[0];

               if (!this.capmasterlist.some((x) => x.cap_id == item.cap_id)) {
                  let index = this.rolecaplist.findIndex((x) => x.cap_id == item.cap_id);
                  this.capmasterlist.push(item);
                  this.rolecaplist.splice(index, 1);
                  this.rolecaplist_select = [];
               }
            }
         },

         caplist_rowClick(item, row) {
            row.select(true);
         },

         capmasterlist_rowClick(item, row) {
            row.select(true);
         },

         async doSaveRole() {
            let response = await this.$http({
               url: "/common/saverole.php",
               headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
               },
               data: {
                  role_name: this.edit_role_name,
                  role_description: this.edit_role_description,
                  role_status: this.edit_role_status.id,
                  rolecaplist: this.rolecaplist,
                  userid: this.$globalstore.user.userid,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.error) {
                  this.$refs.confirm.open("Error", response.data.message, {
                     color: "red",
                     noconfirm: true,
                  });
               } else {
                  this.goBack();
               }
            });
         },

         SaveRole() {
            if (this.$refs.roleform.validate()) {
               this.doSaveRole();
            } else {
               this.$refs.confirm.open("Error", "Please complete the form.", {
                  color: "red",
                  noconfirm: true,
               });
            }
         },
      },

      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.getCapMasterList();
            // Default to enabled
            this.edit_role_status = this.$globalstore.status_select[0];
         }
      },
   };
</script>
